export default {
  component: () => import('./page.vue'),
  path: '/report/:batchId',
  name: 'report',
  meta: {
    title: '测量报告',
    auth: true,
    wechat: {
      AppMessageShare: false,
      TimelineShare: false,
    },
  },
};
